import { render } from "./ConversationChat.vue?vue&type=template&id=0f9d3d3b&scoped=true"
import script from "./ConversationChat.vue?vue&type=script&lang=js"
export * from "./ConversationChat.vue?vue&type=script&lang=js"

import "./ConversationChat.vue?vue&type=style&index=0&id=0f9d3d3b&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9d3d3b"]])

export default __exports__